import { ReferralRewardSettingsModel, RewardModel } from '@shared/types';

import { ReferralRewardSettingsUpdateArgs } from '@services';

import { ReferralValidationFormValues } from '../ReferralValidationForm';

export const getReferralValidationEditFormInitialValues = (
  referralRewardSettings: ReferralRewardSettingsModel,
  initialReferralRewards: RewardModel[],
  initialInviterRewards: RewardModel[]
): ReferralValidationFormValues => {
  const {
    referralValidationRewards: { requiredTasksForValidate, isActive },
  } = referralRewardSettings;

  return {
    inviterRewards: initialInviterRewards,
    referralRewards: initialReferralRewards,
    requiredTasksForValidate,
    isActive,
  };
};

export const getReferralValidationModalFromFormValues = (
  requiredTasksForValidate: number,
  isReferralRewardsEnabled: boolean,
  { id, startDate, ...restReferralRewardSettingsFields }: ReferralRewardSettingsModel,
  inviterRewards: RewardModel[],
  referralRewards: RewardModel[]
): ReferralRewardSettingsUpdateArgs => ({
  ...restReferralRewardSettingsFields,
  referralValidationRewards: {
    referralRewardIds: [...new Set(referralRewards.map((reward) => reward.id))],
    inviterRewardIds: [...new Set(inviterRewards.map((reward) => reward.id))],
    requiredTasksForValidate,
    isActive: isReferralRewardsEnabled,
  },
});
